import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Fig.dtos';

import {
    ACTION_PREREGISTRATIONFORMS_LOAD,
    ACTION_PREREGISTRATIONFORMS_LOAD_BY_ID,
    ACTION_PREREGISTRATIONFORMS_LOAD_BY_PATIENT_ID,
    ACTION_PREREGISTRATIONFORMS_LOAD_BY_PATIENT_IDENTIFIER,
    ACTION_PREREGISTRATIONFORMS_LOAD_SUCCESS,
    ACTION_PREREGISTRATIONFORMS_LOAD_FAILURE,

    ACTION_PREREGISTRATIONFORMS_SAVE,
    ACTION_PREREGISTRATIONFORMS_SAVE_SUCCESS,
    ACTION_PREREGISTRATIONFORMS_SAVE_FAILURE,

    ACTION_PREREGISTRATIONFORMS_CREATE,
    ACTION_PREREGISTRATIONFORMS_CREATE_SUCCESS,
    ACTION_PREREGISTRATIONFORMS_CREATE_FAILURE,

    ACTION_PREREGISTRATIONFORMS_CLEAR,
    PreRegistrationFormAction
} from '../../actions/forms/preRegistrationForm';

import { RequestState } from "../../enumerations/RequestState";
import { IRequestState } from "../index";

export interface IPreRegistrationFormState {
    formData: Dtos.PreRegistrationForm | Dtos.PreRegistrationForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    createState: IRequestState;
}

const initialState: IPreRegistrationFormState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: IPreRegistrationFormState, isLoading: boolean): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IPreRegistrationFormState,
    formData: Dtos.PreRegistrationForm | Dtos.PreRegistrationForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[], responseStatus: Dtos.ResponseStatus
): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return newState;
}

function loadFailure(state: IPreRegistrationFormState, responseStatus: Dtos.ResponseStatus): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: IPreRegistrationFormState, isSaving: boolean): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IPreRegistrationFormState,
    formData: Dtos.PreRegistrationForm | Dtos.PreRegistrationForm[],
    formState: Dtos.RegistrationFormState,
    responseStatus: Dtos.ResponseStatus
): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return newState;
}

function saveFailure(state: IPreRegistrationFormState, responseStatus: Dtos.ResponseStatus): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        }
    });

    return newState;
}

function creating(state: IPreRegistrationFormState, isCreating: boolean): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IPreRegistrationFormState,
    formData: Dtos.PreRegistrationForm,
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[]
): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IPreRegistrationFormState, responseStatus: Dtos.ResponseStatus): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IPreRegistrationFormState): IPreRegistrationFormState {
    const newState: IPreRegistrationFormState = update(initialState, {});

    return newState;
}

const PreRegistrationFormReducer: Reducer<IPreRegistrationFormState> = (state: IPreRegistrationFormState = initialState, action: PreRegistrationFormAction) => {
    switch (action.type) {
        case ACTION_PREREGISTRATIONFORMS_LOAD:
        case ACTION_PREREGISTRATIONFORMS_LOAD_BY_ID:
        case ACTION_PREREGISTRATIONFORMS_LOAD_BY_PATIENT_ID:
        case ACTION_PREREGISTRATIONFORMS_LOAD_BY_PATIENT_IDENTIFIER:
            return loading(state, true);
        case ACTION_PREREGISTRATIONFORMS_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_PREREGISTRATIONFORMS_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_PREREGISTRATIONFORMS_SAVE:
            return saving(state, true);
        case ACTION_PREREGISTRATIONFORMS_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_PREREGISTRATIONFORMS_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_PREREGISTRATIONFORMS_CREATE:
            return creating(state, true);
        case ACTION_PREREGISTRATIONFORMS_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_PREREGISTRATIONFORMS_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_PREREGISTRATIONFORMS_CLEAR:
            return clear(state);
    }

    return state;
}

export default PreRegistrationFormReducer;